import type { ReactNode } from 'react';
import { Icon, AnMark } from '../../components/ui/Icon.js';

/**
 * The frame every signed-out screen shares: ArcNet's green panel on the left, the form centred on
 * the right. Sign in, set your password, an expired invitation and an invitation opened while signed
 * in all use it, so none of them is a lone card in a corner (owner, 18 September 2026: the
 * set-password page was "not centred and small").
 */
export function AuthLayout({ children }: { children: ReactNode }) {
  return (
    <div className="arc-login">
      <aside className="arc-login-brand">
        <div className="arc-row" style={{ gap: 10 }}>
          <AnMark size={30} />
          <span style={{ fontSize: 16, fontWeight: 600, letterSpacing: '-.01em' }}>ArcNet</span>
        </div>

        <div>
          <p className="arc-login-lede">
            One platform for every extension, number and minute.
          </p>
          <ul className="arc-login-points" style={{ marginTop: 22 }}>
            <li><Icon name="check" size={14} />Multi-tenant PBX, one SIP domain per customer</li>
            <li><Icon name="check" size={14} />Queues, IVRs, recording and voicemail</li>
            <li><Icon name="check" size={14} />Rated call records and billing in one place</li>
          </ul>
        </div>

        <div className="arc-login-foot">Cloud communications for South Africa</div>
      </aside>

      <div className="arc-login-panel">
        <div className="arc-login-card">{children}</div>
      </div>
    </div>
  );
}
